import AddButton from './Utils/40-AddButton.jsx'
import Forest from './Plots/00-Forest.jsx'
import Pond from './Plots/01-Pond.jsx'
import Garden from './Plots/02-Garden.jsx'
import Factory from './Plots/03-Factory.jsx'
import Lumberyard from './Plots/04-Lumberyard.jsx'
import PowerPlant from './Plots/05-PowerPlant.jsx'
import Apartment from './Plots/06-Apartment.jsx'
import Townhouses from './Plots/07-Townhouses.jsx'
import Houses from './Plots/08-Houses.jsx'
import Theater from './Plots/09-Theater.jsx'
import Restaurant from './Plots/10-Restaurant.jsx'
import Museum from './Plots/11-Museum.jsx'

import { useState, useEffect } from 'react'
import useVars from './Stores/useVars.jsx'


export default function SinglePlot(props) {
    const plotState = useState(props.plotId)
    let plotId = plotState[0]
    const setPlot = plotState[1]

    let thisPlotCoords = [3 + props.position[0] / 2.5, 3 + props.position[2] / 2.5]

    let targetPlotCoords = [3,3]

    let purchasedPlot = 0
    let built = false

    function PurchasePlot() {
        if(targetPlotCoords[0] == thisPlotCoords[0] && targetPlotCoords[1] == thisPlotCoords[1] && !built) 
        {
            // console.log('you are purchasing a plot', purchasedPlot, targetPlotCoords)
            setPlot(purchasedPlot + 2)
            // console.log(plotId)
            built = true
        }
        
        else if(!built && plotId<1 && (Math.abs(targetPlotCoords[0]-thisPlotCoords[0]) + Math.abs(targetPlotCoords[1]-thisPlotCoords[1])) <= 1)
        {
            // console.log("adjacent")
            setPlot(1)
        }
    }

    useEffect(() => {
        const unsubscribePhase = useVars.subscribe(
            (state) => state.phase,
            (value) =>
            {
                if(value == 'scrolling')
                    PurchasePlot()
            }
        )
        const unsubscribePlot = useVars.subscribe(
            (state) => state.purchasedPlot,
            (value) =>
            {
                purchasedPlot = value
            }
        )
        const unsubscribeCoords = useVars.subscribe(
            (state) => state.plotCoords,
            (value) =>
            {
                // if(value[0] == thisPlotCoords[0] && value[1] == thisPlotCoords[1])
                    targetPlotCoords = value
            }
        )

        return () =>
        {
            unsubscribePhase()
            unsubscribePlot()
            unsubscribeCoords()
        }
    }, [])

    return (<group {...props}>
        {plotId == 1 ? <AddButton position={props.position}/> : null}
        {plotId == 2 ? <Forest built={false}/> : null}
        {plotId == 3 ? <Pond built={false} /> : null}
        {plotId == 4 ? <Garden built={false} /> : null}
        {plotId == 5 ? <Factory built={false} /> : null}
        {plotId == 6 ? <Lumberyard built={false} /> : null}
        {plotId == 7 ? <PowerPlant built={false} /> : null}
        {plotId == 8 ? <Apartment built={false} /> : null}
        {plotId == 9 ? <Townhouses built={false} /> : null}
        {plotId == 10 ? <Houses built={false} /> : null}
        {plotId == 11 ? <Theater built={false} /> : null}
        {plotId == 12 ? <Restaurant built={false} /> : null}
        {plotId == 13 ? <Museum built={false} /> : null}
    </group>)
}